/** FA catalog — تب برنامهٔ درمان (ZOY-667): وضعیت‌های دسترسی، هفته، جلسه‌های برخاسته از نوبت، تکلیف‌های خانگی. */
export const carePlanFa: Record<string, string> = {
  'rec.tab.care-plan': 'برنامه درمان',

  'cp.never.title': 'هنوز خانواده‌ای متصل نیست',
  'cp.never.body':
    'برنامه درمان از طریق ارتباط خانوادگی به اشتراک گذاشته می‌شود. وقتی خانواده‌ای دعوت را بپذیرد، جلسات این پرونده خودکار این‌جا ظاهر می‌شوند و تکالیف خانگی می‌توانند برای خانواده نوشته شوند.',
  'cp.never.goFamily': 'باز کردن تب خانواده',
  'cp.ended.title': 'تاریخچه — همه ارتباط‌های خانوادگی تمام‌شده‌اند',
  'cp.ended.body':
    'آنچه هنگام وصل بودن خانواده به اشتراک گذاشته شد، این‌جا خواندنی می‌ماند. تغییرات تقویم دیگر به اشتراک گذاشته نمی‌شوند، و تا خانواده دوباره وصل نشود هیچ تکلیف خانگی تازه‌ای نوشته نمی‌شود.',
  'cp.readOnly.note':
    'شما می‌توانید این برنامه درمان را بخوانید. نوشتن تکالیف خانگی به مجوز نویسنده برنامه نیاز دارد.',
  'cp.unavailable.title': 'سامانهٔ برنامه فعلاً در دسترس نیست',
  'cp.unavailable.body':
    'این لحظه هیچ‌چیز این‌جا معلوم نیست — حتی این‌که خانواده‌ای وصل است یا نه. کمی بعد دوباره تلاش کنید.',
  'cp.forbidden.title': 'این تب به دسترسی خواندن برنامه نیاز دارد',
  'cp.forbidden.body': 'از مدیر مرکز بخواهید آن را به نقش شما اضافه کند.',
  'cp.retry': 'تلاش دوباره',
  'cp.switchedToHistory':
    'ارتباط خانوادگی همین لحظه پیش تمام شد — این برنامه درمان حالا تاریخچه است. چیزی نوشته نشد.',

  'cp.title': 'برنامه درمان',
  'cp.sub':
    'آنچه خانواده وصل می‌بیند: جلسات مرکز، بازتاب‌یافته از تقویم، و تکالیف خانگی‌ای که مرکز برایشان می‌نویسد.',
  'cp.sessionsNote':
    'جلسه‌ها از نوبت‌ها می‌آیند. برای تغییر یک جلسه، نوبتش را در تقویم تغییر دهید؛ برنامه تا چند دقیقهٔ بعد دنبالش می‌آید.',
  'cp.eventual': 'نوبتی که همین حالا تغییر کرده شاید هنوز این‌جا دیده نشود.',

  'cp.week.title': 'این هفته',
  'cp.week.prev': 'هفته قبل',
  'cp.week.next': 'هفته بعد',
  'cp.week.today': 'این هفته',
  'cp.week.range': '{from} – {to}',
  'cp.week.empty': 'این هفته چیزی زمان‌بندی نشده.',
  'cp.week.failed': 'هفته بارگذاری نشد.',

  'cp.kind.session': 'جلسه · از تقویم',
  'cp.kind.task': 'تکلیف خانگی',
  'cp.session.openBooking': 'باز کردن نوبت',
  'cp.session.practitioner': 'با {name}',
  'cp.session.rescheduled': 'زمان‌بندی تغییر کرده',
  'cp.mode.in_clinic': 'در مرکز',
  'cp.mode.off_site': 'بیرون از مرکز',
  'cp.mode.online': 'آنلاین',

  'cp.st.upcoming': 'پیشِ رو',
  'cp.st.starting_soon': 'به‌زودی شروع می‌شود',
  'cp.st.in_progress': 'در حال برگزاری',
  'cp.st.awaiting_update': 'در انتظار به‌روزرسانی',
  'cp.st.completed': 'انجام‌شده',
  'cp.st.cancelled': 'لغو شده',
  'cp.st.missed': 'غیبت',
  'cp.st.incomplete': 'ناتمام',
  'cp.st.no_longer_updating': 'دیگر به‌روز نمی‌شود',
  'cp.st.to_do': 'برای انجام',
  'cp.st.due_today': 'موعد امروز',
  'cp.st.overdue': 'گذشته از موعد',

  'cp.tasks.title': 'تکلیف‌های خانگی',
  'cp.tasks.sub':
    'نوشته شده توسط مرکز تا خانواده در خانه انجام دهد. خانواده آن‌ها را در برنامه خودش انجام‌شده علامت می‌زند.',
  'cp.tasks.new': 'تکلیف خانگی تازه',
  'cp.tasks.empty': 'هنوز تکلیف خانگی‌ای نیست.',
  'cp.tasks.emptyHint': 'اولین را بنویسید — کاری کوتاه و شدنی برای این هفته.',
  'cp.tasks.due': 'سررسید {when}',
  'cp.tasks.noDue': 'بدون موعد',
  'cp.tasks.by': 'توسط {name}',
  'cp.tasks.edit': 'ویرایش',
  'cp.tasks.markDone': 'ثبت انجام',
  'cp.tasks.reopen': 'بازکردن دوباره',
  'cp.tasks.to.completed': 'ثبت انجام',
  'cp.tasks.to.to_do': 'بازکردن دوباره',
  'cp.tasks.progress': 'پیشرفت خانواده',
  'cp.tasks.progressNone': 'خانواده هنوز پیشرفتی ثبت نکرده.',
  'cp.tasks.progressFailed': 'پیشرفت بارگذاری نشد.',
  'cp.tasks.evidence': '{n, plural, one {# پیوست} other {# پیوست}}',
  'cp.tasks.progressBy.family': 'خانواده',
  'cp.tasks.progressBy.center': 'مرکز',
  'cp.tasks.progressLine': '{who} · {when}',
  'cp.tasks.dueAt': 'سررسید {when}',
  'cp.tasks.dueDay': 'سررسید تا پایان {when}',
  'cp.evidence.item': 'پیوست {n, number}',
  'cp.evidence.open': 'باز کردن پیوست {n, number}',
  'cp.evidence.openTab': 'باز کردن در تب جدید {name}',
  'cp.evidence.close': 'بستن',
  'cp.evidence.gone': 'این پیوست دیگر در دسترس نیست.',
  'cp.evidence.unavailable': 'همین حالا به انبار شواهد دسترسی نیست. کمی بعد دوباره تلاش کنید.',
  'cp.evidence.forbidden': 'شما اجازه باز کردن این پیوست را ندارید.',
  'cp.tasks.hide': 'پنهان کردن',

  'cp.form.newTitle': 'تکلیف خانگی تازه',
  'cp.form.editTitle': 'ویرایش تکلیف خانگی',
  'cp.form.title': 'خانواده چه کاری انجام دهد',
  'cp.form.titleHelp': 'یک کار مشخص، به زبان خود خانواده.',
  'cp.form.due': 'تاریخ موعد',
  'cp.form.dueHelp': 'اختیاری. بدون ساعت، تکلیف تا پایان همان روز، به وقت مرکز، سررسید دارد.',
  'cp.form.time': 'ساعت (اختیاری)',
  'cp.form.timeHelp': '۲۴ ساعته، مثلاً ۱۸:۳۰.',
  'cp.form.create': 'افزودن تکلیف',
  'cp.form.save': 'ذخیره تغییرات',
  'cp.form.created': 'تکلیف خانگی افزوده شد',
  'cp.form.saved': 'تکلیف خانگی ذخیره شد',
  'cp.form.moved': 'تکلیف به {status} منتقل شد',

  'cp.err.generic': 'سرویس برنامه درمان این تغییر را نپذیرفت.',
  'cp.err.sessionNotAuthorable': 'جلسات در تقویم عوض می‌شوند، نه این‌جا.',
  'cp.err.connectionEnded': 'ارتباط خانوادگی تمام‌شده؛ چیز تازه‌ای نوشته نمی‌شود.',
  'cp.err.illegal': 'این جابه‌جایی از وضعیت فعلی تکلیف مجاز نیست. الان مجاز است: {allowed}.',
  'cp.err.illegalNone': 'این جابه‌جایی از وضعیت فعلی تکلیف مجاز نیست.',
  'cp.err.validation': 'سرویس برنامه درمان جزئیات را رد کرد. عنوان و تاریخ را بررسی کنید.',
  'cp.err.unavailable': 'به سرویس برنامه درمان دسترسی نیست. چیزی نوشته نشد — دوباره تلاش کنید.',
  'cp.err.contract':
    'سامانه مرکز و سرویس برنامه درمان درباره این تغییر هم‌نظر نیستند. چیزی نوشته نشد؛ به تیم اطلاع داده شد.',
  'cp.err.forbidden': 'سرویس برنامه درمان این اقدام را از شما نپذیرفت.',
  'cp.err.race': 'یک نفر دیگر همین لحظه این را عوض کرد. بازخوانی کنید و دوباره تلاش کنید.',
  'cp.err.retry': 'تلاش دوباره',
};
